import { SelectMultiple } from '@/components/controls/SelectMultiple';

export function SelectMultipleField({ input: { value, onChange }, ...props }) {
  return <SelectMultiple {...props} value={value} onChange={onChange} />;
}
